<template>
    <div class="news-explore">
        <div class="news-explore-header">
            <router-link class="news-explore-header__close-btn-link" to="/news">
                <img class="news-explore-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>

            <div class="news-explore-header__content-container">
                <div class="news-explore-header__content">
                    <h2 class="news-explore-header__heading" v-html=headerHeadline></h2>
                    <p class="news-explore-header__paragraph" v-html=headerArticlePreview></p>

                    <div class="news-explore-header__read-more-link-container">
                        <a v-if="headerLinkType === 'link'" class="news-explore-header__read-more-link" :href=headerLink target="_blank">Read More</a>
                        <router-link v-else class="news-explore-header__read-more-link" :to=headerLink>Read More</router-link>
                    </div>
                </div>

                <picture>
                    <img class="news-explore-header__placeholder-image" :src=headerImage>
                </picture>
            </div>
        </div>

        <div class="news-explore-articles">
            <div class="news-explore-articles__wrapper">
                <ul class="news-explore-articles__list">
                    <li v-for="newsEntry in newsEntryItems.slice(1)" class="news-explore-articles__item">
                        <div class="news-explore-articles__container">
                            <div class="news-explore-articles__heading-container">
                                <h2 class="news-explore-articles__heading" v-html="newsEntry.headline"></h2>
                            </div>

                            <div class="news-explore-articles__paragraph-container">
                                <div class="news-explore-articles__paragraph-wrapper">
                                    <p class="news-explore-articles__paragraph" v-html="newsEntry.preview"></p>

                                    <a v-if="newsEntry.linkType === 'link'" class="news-explore-articles__link" :href=newsEntry.url target="_blank">Read More</a>
                                    <router-link v-else :to="newsEntry.url" class="news-explore-articles__link">Read More</router-link>
                                </div>
                            </div>

                            <img class="news-explore-articles__image" :src="newsEntry.thumbnail">
                        </div>
                    </li>
                </ul>

                <div class="news-explore-articles__newswire">
                    <h3 class="news-explore-articles__newswire-heading">HUNTER: Newswire</h3>
                    <p class="news-explore-articles__newswire-paragraph">Read the latest <a class="news-explore-articles__newswire-link" href="http://clientnewsfeed.hunterpr.com/" target="_blank">press</a> releases.</p>
                </div>
            </div>
        </div>

        <div class="news-explore-footer">
            <h2 class="news-explore-footer__heading">Learn more...</h2>
            <div class="news-explore-footer__link-container">
                <a href="/work/case-studies" class="news-explore-footer__link">Work</a>
                <a href="/expertise/explore" class="news-explore-footer__link">Expertise</a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .news-explore {
        background-color: #ffffff;
        color: #ffffff;
        overflow-x: hidden;
        position: relative;
    }

    .news-explore-header__content-container {
        max-height: 630px;
        position: relative;

        &:after {
            background-color: #000000;
            content: "";
            height: 100%;
            left: 0;
            opacity: 0.4;
            position: absolute;
            top: 0;
            width: 100%;
        }

        @media @breakpoint__tablet--small {
            height: 100vh;
        }
    }

    .news-explore-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .news-explore-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .news-explore-header {
        height: 0;
        overflow: hidden;
        position:relative;
        width:100%;
    }

    .news-explore-header__content {
        box-sizing: border-box;
        left: 0;
        margin: auto;
        max-width: 1300px;
        padding: 0 50px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        z-index: 10;

        @media @breakpoint__tablet--medium {
            top: 52%;
        }

        @media @breakpoint__mobile--large {
            padding: 0 25px;
            top: 50%;
        }
    }

    .news-explore-header__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 40px;
        line-height: 1.2;
        margin: 0 0 30px;
        max-width: 800px;
        opacity: 0;
        padding-bottom: 50px;
        position: relative;
        transform: translateY(20px);

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 150px;
        }

        @media @breakpoint__tablet--large {
            font-size: 32px;
            padding-bottom: 35px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 24px;
            margin: 0 0 15px;
            padding-bottom: 20px;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            font-size: 26px;
        }

        @media @breakpoint__mobile--small {
            font-size: 24px;
        }
    }

    .news-explore-header__paragraph {
        font-size: 22px;
        line-height: 1.4;
        margin: 0 0 30px;
        opacity: 0;
        transform: translateY(20px);
        width: 800px;

        @media @breakpoint__tablet--large {
            font-size: 18px;
            width: 560px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 16px;
            margin-bottom: 25px;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            font-size: 18px;
        }
    }

    .news-explore-header__read-more-link-container {
        opacity: 0;
        transform: translateY(20px);
    }

    .news-explore-header__read-more-link {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 1.1em;
        letter-spacing: 1.2px;
        line-height: 23px;
        margin: 0;
        padding: 3px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.5s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #ffffff;
            color: #003a4a;
        }
    }

    .news-explore-header__placeholder-image {
        display: block;
        position: relative;
        width: 100%;
        z-index: 0;

        @media @breakpoint__tablet--small {
            height: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: auto;
        }
    }

    .news-explore-articles {
        background-color: #003a4a;
        opacity: 0;
        padding: 60px 0 100px;
        position: relative;

        @media @breakpoint__tablet--large {
            padding: 50px 0 100px;
        }

        @media @breakpoint__mobile--large {
            padding: 50px 0 100px;
        }

        &:after {
            content: "";
            background-color: #ffffff;
            border-radius: 0 0 60px 60px;
            height: 100%;
            position: absolute;
            top: 0;
            width: 100%;
            z-index:0;

            @media @breakpoint__mobile--large {
                border-radius: 0 0 35px 35px;
            }
        }
    }

    .news-explore-articles__wrapper {
        max-width: 1300px;
        margin: 0 auto;
        position: relative;
        z-index: 10;
    }

    .news-explore-articles__list {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .news-explore-articles__item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 50px 50px;
        opacity: 0;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (100px / 3 * 2)");
        vertical-align: top;

        .news-explore-articles__image {
            display: block;
            width: 100%;
            height: 300px;
            object-fit: cover;
        }

        &:nth-child(3n+2) {
            margin: 0;
        }

        @media @breakpoint__tablet--large {
            width: calc(~"(100% / 2) - (75px)");

            &:nth-child(3n+2) {
                margin: 0 50px 50px;
            }

            &:nth-child(2n+2) {
                margin-left: 0;
            }
        }

        @media @breakpoint__tablet--small {
            padding: 0 20px 25px;
            margin: 0 !important;
            width: 100%;
        }
    }

    .news-explore-articles__container {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background-color: #386572;
        border-radius: 55px;
        display: block;
        overflow: hidden;
        position: relative;

        @media @breakpoint__tablet--large {
            border-radius: 50px;
        }

        @media @breakpoint__tablet--medium {
            border-radius: 50px;
        }

        @media @breakpoint__tablet--small {
            border-radius: 50px;
        }

        &:before {
            content: "";
            background-color: #304449;
            height: 100%;
            left: 0;
            opacity: 0.72;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
        }

        &:hover {
            .news-explore-articles__heading-container {
                transform: translateY(-100%);
            }
            .news-explore-articles__paragraph-container {
                transform: translateY(-100%);
            }
        }

        @media @breakpoint__tablet--large {
            &:before {
                opacity: 0.6;
            }

            .news-explore-articles__heading {
                opacity: 1;
                transform: translateY(-50%);
                transition-delay: 0.1s;
            }
        }
    }

    .news-explore-articles__heading-container {
        height: 100%;
        left: 0;
        position: absolute;
        text-align: left;
        top: 0;
        transition: 0.5s transform;
        width: 100%;
        z-index: 10;
    }

    .news-explore-articles__heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        letter-spacing: 1px;
        margin: 0 auto;
        padding-bottom: 20px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 80%;

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 30%;
        }

        @media @breakpoint__tablet--large {
            font-size: 16px;
        }

        @media @breakpoint__tablet--medium{
            font-size: 20px;
        }
    }

    .news-explore-articles__paragraph-container {
        height: 100%;
        left: 0;
        margin: 0 auto;
        position: absolute;
        text-align: left;
        right: 0;
        top: 100%;
        transition: 0.5s transform;
        width: 80%;
        z-index: 10;
    }

    .news-explore-articles__paragraph-wrapper {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .news-explore-articles__paragraph {
        color: #fff;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.4;
        margin: 0 0 20px;
        position: relative;

        @media @breakpoint__tablet--medium{
            font-size: 15px;
        }
    }

    .news-explore-articles__link {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 23px;
        margin: 0;
        padding: 1px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.5s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #ffffff;
            color: #003a4a;
        }
    }

    .news-explore-articles__newswire {
        margin-top: 30px;
        text-align: center;

        &:before {
            content: "";
            border: 0.5px solid #dddddd;
            position: absolute;
            width: 30%;
            transform: translateX(-50%);
        }
    }

    .news-explore-articles__newswire-heading {
        color: #e40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 26px;
        margin: 0 0 15px;
        padding: 50px 0 0;
        position: relative;

        @media @breakpoint__mobile--large {
            font-size: 20px;
        }
    }

    .news-explore-articles__newswire-paragraph {
        color: #003a4a;
        font-size: 20px;
        margin: 0;

        @media @breakpoint__mobile--large {
            font-size: 16px;
        }
    }

    .news-explore-articles__newswire-link {
        color: #e40046;
        text-decoration: none;
    }

    .news-explore-footer {
        background: #003a4a;
        opacity: 0;
        padding: 60px 20px;
    }

    .news-explore-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        line-height: 1;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .news-explore-footer__link-container {
        display: block;
        text-align: center;
    }

    .news-explore-footer__link {
        background-color: #e40046;
        border: none;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        letter-spacing: 1px;
        padding: 10px 30px;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>

<script src="https://player.vimeo.com/api/player.js"></script>

<script>
    export default {
        name: "NewsExplore",
        data: function()
        {
            return {
                headerHeadline : "",
                headerArticlePreview : "",
                headerImage : "",
                headerImageAltText : "",
                headerLink : "",
                headerLinkType : "",
                headerSlug: "",
                newsEntryItems : []
            }
        },
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initHeader(vm.$parent.modelNews);
                    vm.initNewsEntries(vm.$parent.modelNews);
                    vm.initAnimIn();
                    vm.initSubTitle();
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initHeader : function(data)
            {
                this.headerHeadline = data[0].Headline;
                this.headerArticlePreview = data[0].ArticlePreview;
                this.headerImage = data[0].ArticleImageMain;
                this.headerImageAltText = data[0].ArticleImageAltText;
                this.headerLinkType = data[0].ArticleLinkType;

                if (this.headerLinkType === "link")
                {
                    this.headerLink = data[0].ArticleLink;
                }
                else
                {
                    this.headerLink = "/news/newswire/" + data[0].ArticleLink;
                }

            },
            initAnimIn : function()
            {
                TweenMax.set(".news-explore-header", {height:"auto"});
                TweenMax.from(".news-explore-header", 0.6, {height:0, ease: Power2.easeOut, delay: 0.2});

                var tl = new TimelineMax();
                tl.to(".news-explore-header__heading", 0.5, {transform: "translateY(0)", opacity: 1}, "+=0.8");
                tl.to(".news-explore-header__paragraph", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.2");
                tl.to(".news-explore-header__read-more-link-container", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.2");
                tl.from(".news-explore__close-btn", 0.6, {transform: "scale(0)", ease: Back.easeOut.config(2)}, "-=0.2");
                tl.set(".news-explore-articles", {opacity: 1}, "-=0.2");

                setTimeout(function()
                {
                    tl.staggerTo(".news-explore-articles__item", 0.6, {transform: "translateY(0)", opacity: 1}, 0.3, "-=0.4");
                }, 500);

                tl.set(".news-explore-footer", {opacity: 1}, "-=0.2");
            },
            initNewsEntries : function(data)
            {
                var newsData = data;
                this.newsEntryItems = [];

                for(var i = 0; i < newsData.length; i++)
                {
                    var newsEntry = {};
                    newsEntry.headline = newsData[i].Headline;
                    newsEntry.thumbnail = newsData[i].ArticleImageThumbnail;
                    newsEntry.thumbnailAltText = newsData[i].ArticleImageAltText;
                    newsEntry.preview = newsData[i].ArticlePreview;
                    newsEntry.linkType = newsData[i].ArticleLinkType;

                    if(newsEntry.linkType === "link")
                    {
                        newsEntry.url = newsData[i].ArticleLink;
                    }
                    else
                    {
                        newsEntry.url = "/news/newswire/" + newsData[i].Slug;
                    }

                    this.newsEntryItems.push(newsEntry);
                }

                TweenMax.set(".news-explore__item", {opacity: 0, transform: "translateY(50%)"});

                setTimeout(function()
                {
                    TweenMax.staggerFromTo(".news-explore__item", 0.6, {autoAlpha: 0, transform: "translateY(50%)"}, {autoAlpha: 1, transform: "translateY(0)", ease: Power2.easeOut}, 0.1);
                }, 500);
            },
            initSubTitle : function() {
                document.querySelector(".header__logo-sub-title").innerHTML = "News";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            onPlayButtonClick : function()
            {
                TweenMax.to(".news-explore-header__content-container", 0.2, {opacity:0, onComplete: this.initVideo});
            },
            initVideo : function()
            {
                TweenMax.set(".news-explore-header__content-container", {opacity:1});

                document.querySelector(".news-explore-header__content-container").innerHTML = '<div id="sizzle-reel" style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/319507392?color=e40046&title=0&byline=0&portrait=0&autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay; encrypted-media"></iframe></div>';
            }
        }
    };
</script>
